module.exports = __webpack_public_path__ + "static/media/four.f149959b.svg";